import React from 'react';
import Icon from '../../../components/AppIcon';
import ProjectCard from './ProjectCard';

const ProjectPipeline = ({ projects, selectedProject, onSelectProject, onDragStart, onDragOver, onDrop }) => {
  const phases = [
    { id: 'planning', label: 'Planning', icon: 'ClipboardList', color: 'bg-primary' },
    { id: 'permits', label: 'Permits', icon: 'FileCheck', color: 'bg-accent' },
    { id: 'foundation', label: 'Foundation', icon: 'Layers', color: 'bg-secondary' },
    { id: 'framing', label: 'Framing', icon: 'Box', color: 'bg-primary' },
    { id: 'systems', label: 'Systems', icon: 'Zap', color: 'bg-warning' },
    { id: 'finishing', label: 'Finishing', icon: 'Paintbrush', color: 'bg-accent' },
    { id: 'completed', label: 'Completion', icon: 'CheckCircle2', color: 'bg-success' }
  ];

  const getProjectsByPhase = (phaseId) => {
    return projects?.filter(project => project?.phase === phaseId);
  };

  return (
    <div className="flex gap-4 md:gap-6 overflow-x-auto pb-4 min-h-[600px]">
      {phases?.map((phase) => {
        const phaseProjects = getProjectsByPhase(phase?.id);
        
        return (
          <div
            key={phase?.id}
            className="flex-shrink-0 w-80 md:w-96"
            onDragOver={(e) => onDragOver(e)}
            onDrop={(e) => onDrop(e, phase?.id)}
          >
            <div className="bg-muted/50 rounded-xl p-4 md:p-5 h-full">
              <div className="flex items-center justify-between mb-4 md:mb-5">
                <div className="flex items-center gap-2 md:gap-3">
                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg ${phase?.color} flex items-center justify-center`}>
                    <Icon name={phase?.icon} size={18} color="#FFFFFF" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-sm md:text-base text-foreground">
                      {phase?.label}
                    </h3>
                    <p className="text-xs text-muted-foreground">
                      {phaseProjects?.length} project{phaseProjects?.length !== 1 ? 's' : ''}
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-3 md:space-y-4">
                {phaseProjects?.length === 0 ? (
                  <div className="bg-card/50 rounded-lg p-6 md:p-8 text-center border-2 border-dashed border-border">
                    <Icon name="Inbox" size={32} className="mx-auto mb-2 text-muted-foreground" />
                    <p className="text-sm text-muted-foreground">No projects in this phase</p>
                  </div>
                ) : (
                  phaseProjects?.map((project) => (
                    <div
                      key={project?.id}
                      draggable
                      onDragStart={(e) => onDragStart(e, project)}
                    >
                      <ProjectCard
                        project={project}
                        onSelect={onSelectProject}
                        isSelected={selectedProject?.id === project?.id}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectPipeline;